// نصوص الإشعارات بالعربية — الرموز تبقى إنجليزية كما يعيدها الخادم.
import type { NotificationSeverity } from '../lib/api.ts';

export const SEVERITY_AR: Record<NotificationSeverity, string> = {
  INFO: 'معلومة',
  WARNING: 'تنبيه',
  CRITICAL: 'حرج',
};

export const SEVERITY_TONE: Record<NotificationSeverity, string> = {
  INFO: 'bg-slate-100 text-ink-700',
  WARNING: 'bg-amber-100 text-amber-900',
  CRITICAL: 'bg-rose-100 text-rose-800',
};
